<template>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
        <div class="warp-block">
            <div class="block" v-for="(item,index) in listTitle" :key="index">
                <span>{{item.title}}</span>
                <span>{{item.value}}</span>
            </div>
        </div>
        <div class="warp-btn">
            <el-button :type='indexNo==index ? "primary":""' primary size="small" v-for="(item,index) in BtnList" :key="index" @click="tebBtn(index)">{{item.title}}</el-button>
        </div>
        <div class="common-width">
           <ListTOPUP v-if="indexNo==0" :belongToType="belongToType" :belongToId="belongToId"></ListTOPUP>
           <ListEQ    v-if="indexNo==1" :belongToType="belongToType" :belongToId="belongToId"></ListEQ>
           <ListVoice v-if="indexNo==2" :belongToType="belongToType" :belongToId="belongToId"></ListVoice>
        </div>
    </el-dialog>
</template>
<script>
import { postFun,httpImg,exportFun } from '@/utils/httpFun'
import {url,api,operate} from '@/utils/config'
import ListTOPUP from './../module-block/list-topup/index.vue'
import ListEQ from './../module-block/list-eq/index.vue'
import ListVoice from './../module-block/list-voiceSms/index.vue'
export default {
    components: {
        ListTOPUP:ListTOPUP,
        ListEQ:ListEQ,
        ListVoice:ListVoice
    },
    data:()=>({
        indexNo:0,
        title:"",
        BtnList:[
            {title:"充值记录",width:"1200px"},
            {title:"设备续费",width:"1300px"},
            {title:"短信语音",width:"1200px"}
        ],
        dialogVisible:false,
        listTitle:[],
        payType:4,
        rechargeAmount:100,
        belongToType:'',
        belongToId:''
    }),
    mounted(){
        
    },
    methods:{
        tebBtn(ev){
           this.indexNo = ev
        },
        openBtn(ev){

            let list =  this.$store.state.conText.accountTypeList
                for(var i in list){
                   if(list[i].val == ev.belongToType){
                    this.title = ev.belongToName+"("+list[i].title+")"
                   }
                }
           
            this.belongToId = ev.belongToId+''
            this.belongToType = ev.belongToType+''
            let parms = {
                belongToId:ev.belongToId,
                belongToType:ev.belongToType,
            }
            postFun(api.Operate+"/financeManager/getFinancialLedgerByDetails",parms,res=>{
                this.listTitle = [
                    // {title:"账户ID：",value:res.data.belongToId},
                    {title:"省市区县：",value:res.data.areaAddress},
                    {title:"账户充值总余额：",value:res.data.accountRechargeTotalAmount+"元"},
                    {title:"账户充值余额：",value:res.data.accountRechargeBalance+"元"},
                    {title:"赠送总金额：",value:res.data.giveTotalAmount+"元"},
                    {title:"赠送余额：",value:res.data.giveBalance+"元"},
                    {title:"钱包余额：",value:res.data.walletBalance+"元"},
                    {title:"创建时间：",value:res.data.createTime},
                    {title:"短信充值总金额：",value:res.data.smsRechargeAmount+"元"},
                    {title:"短信总量：",value:res.data.smsTotalNum+"元"},
                    {title:"短信剩余：",value:res.data.smsBalanceNum+"元"},
                    {title:"语音充值总金额：",value:res.data.voiceRechargeAmount+"元"},
                    {title:"语音总量：",value:res.data.voiceTotalNum+"元"},
                    {title:"语音剩余：",value:res.data.voiceBalanceNum+"元"},
                    {title:"收益总金额：",value:res.data.totalRevenue+"元"},
                    {title:"提现总金额：",value:res.data.withdrawalTotalAmount+"元"},
                    {title:"待提现金额：",value:res.data.unWithdrawalAmount+"元"},
                ]
                this.dialogVisible = true
            })
        },
        //充值提交
        submitBtn(){
            let parms = {
                belongToId:this.belongToId,
                belongToType:this.belongToType,
                payType:this.payType,
                rechargeAmount:this.rechargeAmount
            }
            let urls = this.payType==4 ? api.Operate+"/rechargeManager/offlineRecharge" : api.Operate+"/rechargeManager/giveAmount"
            postFun(urls,parms,res=>{
                if(res.data.result){
                    this.$emit("resetBtn") 
                    this.handleClose()
                }
            })
        },
        handleClose(){
            this.dialogVisible = false
        }  
    }
}
</script>
<style scoped >
  .warp-block{
    display: flex;
    flex-wrap: wrap;
  }
  .warp-btn{
    border: 1px solid #E1E1E1;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;
  }
  .block{
     width:25%;
     margin-bottom: 10px;
  }
  .titleT{
     font-size: 16px;
     font-weight: 700;
  }
</style>